module.exports = __webpack_public_path__ + "static/media/11.e2f2ea72.jpg";